import { render, staticRenderFns } from "./WithIcons.vue?vue&type=template&id=02609ca2"
import script from "./WithIcons.vue?vue&type=script&lang=js"
export * from "./WithIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports